import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-regular.css";
import { CloseButton } from "../components/buttons/close-button";

interface PropertyPalHeaderProps {
  onClose: () => void;
}

const componentContainer =
  "flex p-4 w-full items-center justify-between gap-2.5 self-stretch bg-north-sea rounded-t-lg border-solid border-b border-b-foggy-firth";
const nameContainer = "flex flex-1";
const nameStyles = "text-neutral-white font-semibold text-body-l leading-none md:leading-none";
// CloseButton ships a loch outline focus ring for light backgrounds. On the north-sea header we
// recolour the icon white, shift its shade on hover/press, and override the focus ring to an
// inset white shadow so it remains visible on the dark background.
const closeButtonStyles =
  "text-neutral-white transition-colors " +
  "hover:bg-transparent hover:text-neutral-white/80 " +
  "active:bg-transparent active:text-neutral-white/60 ";

export const PropertyPalHeader: React.FC<PropertyPalHeaderProps> = ({ onClose }) => {
  return (
    <div className={componentContainer}>
      <div className={nameContainer}>
        <div className={nameStyles}>Edi - Your Property Pal</div>
      </div>
      <CloseButton
        onClick={onClose}
        aria-label="Close chatbot"
        className={closeButtonStyles}
        iconClassName="text-2xl size-6"
      />
    </div>
  );
};
